'use es6';

import { http } from '../features/http';
import { BASE_URI } from '../constants/ApiConstants';
export const ACHIEVEMENTS = `${BASE_URI}/achievements`;
export const postNewAchievement = ({
  firstName,
  lastName,
  email,
  language,
  urlSlug,
  visibilityType,
  trackId
}) => http.post(ACHIEVEMENTS, {
  data: {
    achievementType: 'SINGLE',
    visibilityType,
    tracks: [trackId],
    firstName,
    lastName,
    email,
    metadata: {
      [language]: {
        urlSlug
      }
    }
  }
});
export const putAchievementUpdate = (publicId, data) => http.put(`${ACHIEVEMENTS}/${publicId}`, {
  data
});
export const fetchAchievementsAll = () => http.get(ACHIEVEMENTS);